module.exports = __webpack_public_path__ + "assets/images/logo-chinese-inverse.png";


/*****************
 ** WEBPACK FOOTER
 ** ./src/images/logo-chinese-inverse.png
 ** module id = 25
 ** module chunks = 0
 **/